<template>
    <all-topics type="tags" />
</template>

<script>
import AllTopics from './All'

export default {
    components: { AllTopics },
    name: 'Tags',
}
</script>

